import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/home/merchant-login',
    method: 'post',
    data,
  });
}

export function getCodeImg(params) {
  return request({
    url: '/home/getCaptcha',
    method: 'get',
    params,
  });
}

export function modifyPwd(data) {
  return request({
    url: '/home/findPassword',
    method: 'post',
    data,
  });
}
export function modifyPassword(data) {
  return request({
    url: '/merchant-info/modifyPassword',
    method: 'post',
    data,
  });
}

export function sendSmsCode(params) {
  return request({
    url: '/home/getForgetPasswordSms',
    method: 'get',
    params,
  });
}

export function logout(params) {
  return request({
    url: '/home/merchant-logout',
    method: 'get',
    params,
  });
}

export function getSmsByVecode(params) {
  return request({
    url: '/home/getSmsByVecode',
    method: 'get',
    params,
  });
}
